import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import type { ReactNode } from "react";

export const TooltipProvider = TooltipPrimitive.Provider;

/**
 * The shadcn/Radix tooltip, restyled entirely through the ported tokens rather than
 * used with its stock look — which is what UI-2 asks of every primitive here.
 */
export function Tooltip({
  label,
  side = "bottom",
  children,
}: {
  label: ReactNode;
  side?: "top" | "right" | "bottom" | "left";
  children: ReactNode;
}) {
  if (!label) return <>{children}</>;

  return (
    <TooltipPrimitive.Root>
      <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
      <TooltipPrimitive.Portal>
        <TooltipPrimitive.Content
          side={side}
          sideOffset={6}
          className="z-[300] max-w-[260px] rounded-[var(--radius-md)] border border-[var(--border-subtle)] bg-[var(--surface-3)] px-2 py-1 text-[length:var(--text-xs)] text-[var(--text-primary)] shadow-[var(--shadow-lg)]"
        >
          {label}
        </TooltipPrimitive.Content>
      </TooltipPrimitive.Portal>
    </TooltipPrimitive.Root>
  );
}
